import _ from 'underscore';
import templateStr from 'text!./estwages-location.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        scope: {},
        controller: ['$filter', '$scope', 'ActivityService', 'gatewayParamConfig', '$stateParams', function ($filter, $scope, ActivityService, gatewayParamConfig, $stateParams) {}]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/EstWagesLocationDirective_MSF/EstWagesLocation.js
// module id = 1740
// module chunks = 0